/**
 * The base URL for the workadventure assets.
 * This file is updated dynamically during the package build process.
 */
export const workadventureAssetsHtmlUrl = "https://admin.workadventu.re/html";
